module.exports = __webpack_public_path__ + "img/prize-2.0d6bf9c6.png";